import { sizes } from "../utils";
import type { MontaSVGProps } from "../types";
const ArrowRight = ({
  size = "medium",
  color = "inherit",
  ...props
}: MontaSVGProps) => {
  const computedSize = sizes[size] || size;
  props.style = {
    ...props.style,
    color
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      viewBox="0 0 17 15"
      width={computedSize}
      height={computedSize}
      {...props}
    >
      <g fill="#1D2939" fillRule="evenodd" clipRule="evenodd">
        <path d="M0 7.727a.75.75 0 0 1 .75-.75h15a.75.75 0 0 1 0 1.5h-15a.75.75 0 0 1-.75-.75" />
        <path d="M9.04 1.345a.75.75 0 0 1 1.016-.304l-.356.66.356-.66.002.001.004.002.015.008.054.03.201.114a25.73 25.73 0 0 1 2.85 1.886c.778.597 1.585 1.304 2.203 2.061.605.74 1.115 1.63 1.115 2.581s-.51 1.842-1.115 2.582c-.618.758-1.425 1.465-2.203 2.063a26 26 0 0 1-3.05 2l-.055.03-.015.008-.004.002h-.002L9.7 13.75l.357.66a.75.75 0 0 1-.713-1.32l.002-.001.012-.006.046-.026.184-.104a24.182 24.182 0 0 0 2.68-1.775c.734-.563 1.44-1.19 1.956-1.82.53-.65.776-1.203.776-1.634s-.246-.983-.776-1.632c-.516-.63-1.222-1.257-1.956-1.82a24 24 0 0 0-2.864-1.878l-.046-.025-.011-.006-.003-.002M9.04 1.345a.75.75 0 0 0 .304 1.016z" />
      </g>
    </svg>
  );
};
export default ArrowRight;
